import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs/index';
import { STORE_FEATURE_KEY_CONNECTION_PROFILES } from './connection-profiles.reducer';

const loadingSelector = (appState: any) => appState[STORE_FEATURE_KEY_CONNECTION_PROFILES].loading;
const connectionProfilesSelector = (appState: any) => appState[STORE_FEATURE_KEY_CONNECTION_PROFILES].connectionProfiles;
const isUpdated = (appState: any) => appState[STORE_FEATURE_KEY_CONNECTION_PROFILES].isUpdated;

@Injectable()
export class ConnectionProfilesSelectors {
    constructor(private store: Store<any>) {
    }

    selectConnectionProfiles(): Observable<Array<any>> {
        return this.store
            .pipe(select(connectionProfilesSelector));
    }

    selectLoading(): Observable<boolean> {
        return this.store.pipe(select(loadingSelector));
    }

    selectIsUpdated(): Observable<boolean> {
        return this.store.pipe(select(isUpdated));
    }
}
